import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path, Rect, Circle } from "react-native-svg"

function SvgChecklistIcon(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} fill="none" viewBox="0 0 27 27" {...props}>
            <Path
                fill={baseColors.green.primary}
                d="M3 .771h16.971c1.066 0 1.929.864 1.929 1.93V27H4.929A1.929 1.929 0 013 25.07V.771z"
            />
            <Path
                fill={baseColors.green.pastel}
                d="M4.543 2.314h13.886c1.065 0 1.928.864 1.928 1.929v21.214H6.472a1.929 1.929 0 01-1.929-1.928V2.314z"
            />
            <Rect width={9.257} height={0.771} x={8.4} y={8.485} fill="#fff" rx={0.386} />
            <Rect width={10.029} height={0.771} x={8.4} y={12.343} fill="#fff" rx={0.386} />
            <Rect width={6.557} height={0.771} x={8.4} y={16.2} fill="#fff" rx={0.386} />
            <Rect width={10.029} height={0.771} x={8.4} y={20.058} fill="#fff" rx={0.386} />
            <Circle cx={6.674} cy={8.935} r={0.386} fill="#fff" />
            <Circle cx={6.674} cy={12.792} r={0.386} fill="#fff" />
            <Circle cx={6.674} cy={16.649} r={0.386} fill="#fff" />
            <Circle cx={6.674} cy={20.506} r={0.386} fill="#fff" />
            <Path
                fill={baseColors.green.dark}
                d="M9.576 1.972c0-.181.147-.328.329-.328h5.26c.183 0 .33.147.33.328v1.316H9.576V1.972zm.987-1.643c0-.182.147-.329.328-.329h3.288a.33.33 0 01.33.329v1.315h-3.947V.329z"
            />
            <Circle cx={19.2} cy={21.986} r={3.857} fill={baseColors.orange.primary} />
            <Path
                fill="#fff"
                d="M18.266 21.608a.29.29 0 00-.446.37l.446-.37zm.577 1.149l-.223.184.183.22.222-.18-.182-.224zm2.082-1.319a.29.29 0 10-.364-.449l.364.45zm-3.105.54l.8.963.446-.369-.8-.964-.446.37zm1.205 1.003l1.9-1.543-.364-.449-1.9 1.543.364.45z"
            />
        </Svg>
    )
}

export default SvgChecklistIcon
